<template>
  <price-last-mile-list />
</template>

<script>
import PriceLastMileList from '@/components/Cargo/Price/priceLastMileList'

export default {
  name: 'PriceLastMile',
  components: {
    PriceLastMileList
  }
}
</script>

<style scoped lang="scss">

</style>
